import * as yup from 'yup';
import { nullableImageFromCMSSchema } from '@web/cms';
import { header, footer } from '../../cms/builders/';
import { schema as didYouKnowInfoSchema } from './did_you_know_info';
import { schema as pupInfoFormSchema } from './pup_info_form';
import { schema as customerContactFormSchema } from './customer_contact_form';
import { schema as tipsSchema } from './tips';
import { schema as reviewModalSchema } from './review_modal';
import { schema as stepResultSchema } from './step_result';

export const schema = yup
  .object({
    header: header.schema,
    footer: footer.schema,
    stepTitle: yup.string(),
    stepDescription: yup.string(),
    buttonText: yup.string(),
    headerImage: nullableImageFromCMSSchema,
    tips: tipsSchema.optional(),
    reviewModal: reviewModalSchema.optional(),
    didYouKnowInfo: didYouKnowInfoSchema.optional(),
    body: yup.array(),
    seoTitle: yup.string(),
    taggingPrefix: yup.string(),
    form: yup.lazy(form => {
      switch (form?.component) {
        case 'customer_contact_form':
          return customerContactFormSchema.optional();
        default:
          return pupInfoFormSchema.optional();
      }
    }),
    stepResult: stepResultSchema.optional(),
  })
  .transform(value => ({
    header: value.header,
    footer: value.footer,
    body: value.body,
    stepTitle: value.step_title,
    stepDescription: value.step_description,
    didYouKnowInfo: value.did_you_know_info,
    buttonText: value.button_text,
    headerImage: value.header_image,
    tips: value.tips,
    reviewModal: value.review_modal,
    seoTitle: value.seo_title,
    taggingPrefix: value.tagging_prefix,
    form: value.form,
    stepResult: value.step_result,
  }));
